import React from 'react';
import { Moon, BatteryWarning, Activity } from 'lucide-react';
export function HookSection() {
  return <section className="px-4 py-8 bg-white max-w-md mx-auto rounded-3xl shadow-sm my-4 border border-sage/20" data-id="element-61">
      <h2 className="text-2xl font-bold mb-6 text-darkslate leading-tight" data-id="element-62">
        Son las 11 de la noche. Estás agotado pero tu cabeza no para...
      </h2>

      <div className="space-y-4 text-gray-700" data-id="element-63">
        <p data-id="element-64">
          Te acostás esperando descansar, pero el cerebro sigue a mil por hora.
          Al día siguiente, te levantás más cansado de lo que te acostaste.
        </p>
        <p data-id="element-65">
          Te mirás al espejo y notás esa{' '}
          <strong data-id="element-66">hinchazón en el abdomen</strong> que no se va con nada.
          Probaste dejar las harinas, hacer ayuno, matarte en el gimnasio...
          pero la balanza no se mueve y la ropa te sigue apretando.
        </p>
        <p className="font-semibold text-darkslate bg-sage/10 p-4 rounded-xl border-l-4 border-sage" data-id="element-67">
          ¿Te suena familiar? No es falta de voluntad. Es tu cuerpo en modo
          "supervivencia".
        </p>
      </div>

      <div className="mt-8 grid grid-cols-3 gap-2 text-center" data-id="element-68">
        <div className="flex flex-col items-center p-3 bg-offwhite rounded-xl" data-id="element-69">
          <Moon className="w-6 h-6 text-sage-dark mb-2" data-id="element-70" />
          <span className="text-xs font-medium" data-id="element-71">Insomnio</span>
        </div>
        <div className="flex flex-col items-center p-3 bg-offwhite rounded-xl" data-id="element-72">
          <BatteryWarning className="w-6 h-6 text-sage-dark mb-2" data-id="element-73" />
          <span className="text-xs font-medium" data-id="element-74">Fatiga</span>
        </div>
        <div className="flex flex-col items-center p-3 bg-offwhite rounded-xl" data-id="element-75">
          <Activity className="w-6 h-6 text-sage-dark mb-2" data-id="element-76" />
          <span className="text-xs font-medium" data-id="element-77">Ansiedad</span>
        </div>
      </div>
    </section>;
}